const userType = {
  MEMBER: 4,
  MANAGER: 2,
  PRESIDENT: 1
}

export { userType }
